<template>
  <ThresholdInputStyled>
    <div class="type">{{ $t('planning.threshold') }}</div>
    <div class="input">
      <InputStyled type="number" min="0" :value="threshold" @input="$emit('update:threshold', Number($event.target.value))" />
      <div v-if="unit">{{ unit }}</div>
    </div>
  </ThresholdInputStyled>
</template>
<script>
import { styled } from '@egoist/vue-emotion'
import chroma from 'chroma-js'

const ThresholdInputStyled = styled('div')`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.colors.atomic.iconBG};
  color: ${({ theme }) => chroma(theme.colors.atomic.textMain).alpha(0.7).css()};
  align-items: center;
  font-size: 14px;
  gap: 1rem;
  padding: 0.25rem 0.5rem;
  border-radius: 5px;
  .type{
    text-transform: capitalize;
  }
  .input {
    display: flex;
    flex-direction: row;
    background: ${p => chroma(p.theme.colors.atomic.healthStatusIconBG).css()};
    align-items: center;
    padding: 0 0.2rem;
    font-size: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }
`
const InputStyled = styled('input')`
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  padding: 0.5rem 1rem;
  color: ${p => p.theme.colors.primary};
  background: ${p => chroma(p.theme.colors.atomic.healthStatusIconBG).css()};
  border-bottom: 1px solid ${p => chroma(p.theme.colors.navFontNormal).alpha(0.8).css()};
  transition: border-color 0.5s ease;
  &:focus {
    border-color: ${p => p.theme.colors.primary};
  }
  &::placeholder {
    color: ${p => p.theme.colors.primary};
  }
`

export default {
  components: {
    ThresholdInputStyled,
    InputStyled,
  },
  props: {
    threshold: {
      type: Number,
    },
    unit: {
      type: String,
    },
  },
}
</script>
